// extracted by mini-css-extract-plugin
export default {"wrapdiv":"sixth_wrapdiv__dqvT0","section":"sixth_section__z6C78"};